import Grid from "components/primitives/Grid";
import Tables from "components/Tables";
import { tableCells } from "../AthleteTable.config";
import Divider from "@mui/material/Divider";
import CanDoAction from "components/CanDoAction";
import Paper from "@mui/material/Paper";
import AthleteTableIconButtonControls from "./AthleteTableIconButtonControls";
import AthleteTableBulkOneRepMaxUpload from "./AthleteTableBulkOneRepMaxUpload";
import ArchivedAthletesAction from "./ArchivedAthletesAction";

interface AthleteTableControlsProps {}

function AthleteTableControls(props: AthleteTableControlsProps) {
  return (
    <>
      <Grid {...Tables.controlsContainerProps}>
        <Grid {...tableCells.name} size={{ xs: 6, lg: 3 }} sx={{ minWidth: 270, padding: "0 8px" }}>
          <Tables.Components.SearchTextInput />
        </Grid>
        <Grid size="grow">
          <Paper sx={{ boxShadow: "none", display: { xs: "none", md: "none", lg: "block" } }}>
            <AthleteTableIconButtonControls />
          </Paper>
        </Grid>
        <CanDoAction action="athlete.archive">
          <Grid sx={{ minWidth: 0, paddingRight: "8px" }}>
            <ArchivedAthletesAction />
          </Grid>
        </CanDoAction>
        <CanDoAction action="athlete.bulkEdit1rm">
          <Grid sx={{ minWidth: 0, paddingRight: "8px" }}>
            <AthleteTableBulkOneRepMaxUpload />
          </Grid>
        </CanDoAction>
      </Grid>
      <Paper sx={{ boxShadow: "none", display: { lg: "none" } }}>
        <Grid>
          <Grid
            container
            sx={{
              width: "100%",
            }}
          >
            <Grid size={12}>
              <Divider />
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="end"
          sx={{
            width: "100%",
          }}
        >
          <Grid
            {...Tables.controlsContainerProps}
            container={false}
            sx={{ paddingLeft: "8px", justifyContent: "center" }}
          >
            <AthleteTableIconButtonControls />
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export default AthleteTableControls;
